import styles from '../scss/dashboard-trader.scss';

const tabs = $('.tabs').find($('button'));
const collapsibles = $('.collapsible-container').find('.collapsible');

/* ============= Tab functionality =========== */
// selects current tab and changes the style
$(tabs).on('click', function () {
  const previousTab = $('.tabs').find('.active');
  const previousTabName = $(previousTab).attr('name');
  const selectedTabName = $(this).attr('name');

  // Resets the expands all button and any collapsible
  $('.expand-all').html(' Expand All + ');
  $('.collapsible-content').slideUp('fast');
  $('.collapsible-button').html('+');

  // Hides and reverts previous tab and content
  $('#' + previousTabName).hide();
  $(previousTab).attr('class', 'tablinks');

  // Shows selected tab and content
  $(this).attr('class', 'active');
  $('#' + selectedTabName).show();
});

/* ============ Collapsible functionality ============== */
// expand/close all button functionality
$('.expand-all').on('click', function () {
  if ($(this).text() === ' Expand All + ') {
    $(this).html(' Close All - ');
    $('.collapsible-content').slideDown('fast');
    $('.collapsible-button').html('-');
  } else {
    $(this).html(' Expand All + ');
    $('.collapsible-content').slideUp('fast');
    $('.collapsible-button').html('+');
  }
});

// individual collapsible functionality
$(collapsibles).on('click', function () {
  const collapsible = $(this).find('.collapsible-content');
  const button = $(this).find('button')[0];
  if (collapsible.css('display') === 'none') {
    $(button).html('-');
    collapsible.slideDown('fast');
    $('.expand-all').html(' Close All - ');
  } else {
    $(button).html('+');
    collapsible.hide('fast');
  }
});

/* ========== Modal Functionality ============= */
const styleVideoButton = $('.style-video-button');
const modal = $('#myModal');
const closeModalButton = $('.close');

const closeModal = (evt) => {
  const selected = $(evt.target);
  if (selected.is(modal) || selected.is(closeModalButton)) {
    const videoEl = document.getElementById('heroVidModal');
    if (videoEl) {
      videoEl.pause();
      videoEl.currentTime = 0;
    }
    modal.hide();
  }
};

styleVideoButton.on('click', function () {
  const videoEl = document.getElementById('heroVidModal');
  if (videoEl) {
    videoEl.play();
  }
  modal.show();
});

closeModalButton.on('click', closeModal);
modal.on('click', closeModal);
